import styled from "styled-components";

export const Select = styled.select`
  display: flex;
  align-items: center;

  gap: 4px;
  width: 69px;
  padding: 12px 4px 12px 12px;

  border-radius: 8px;
  border: none;
  background: white;

  box-shadow: 2px 4px 9px 0px rgba(166, 141, 174, 0.28);
  outline: none;
`;
